export const textTranslations = (section, language, props) => {
    if(language === "english") {
        if(section === "payment") {
            return <span>Payment was successful!</span>
        }
        if(section === "upload") {
            return <span>File upload was successful!</span>
        }
        if(section === "acknowledged") {
            return <span>Done!</span>
        }
    } else if(language === "sinhala") {
        if(section === "payment") {
            return <span>ගෙවීම් සාර්ථකයි!</span>
        }
        if(section === "upload") {
            return <span>ගොනු උඩුගත කිරීම සාර්ථකයි!</span>
        }
        if(section === "acknowledged") {
            return <span>අවසන්!</span>
        }
    }
}